export default "__VITE_ASSET__06f78738__"